import { SearchOutlineIcon } from "@/components/icon/SearchOutlineIcon";
import { TextInput } from "flowbite-react";

interface Props {
  keyword: string;
  placeholder?: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PartnerNameSearch: React.FC<Props> = ({
  keyword,
  placeholder = "파트너명을 입력해 검색하세요",
  handleSearchChange,
}) => {
  return (
    <TextInput
      id="keyword"
      type="text"
      className="w-[396px]"
      icon={SearchOutlineIcon}
      placeholder={placeholder}
      required
      value={keyword}
      onChange={handleSearchChange}
    />
  );
};
